import React from 'react';
import { getOrgBrandName } from '../../../config/storeConfig';
import { useStoreState } from '../../../store';
import { AppHeaderBackLink, AppHeaderCartLink } from './AppHeaderNavActions';
import { useAppHeaderNav } from './useAppHeaderNav';

const Header: React.FC = () => {
  const orgId = useStoreState(state => state.orgContext.orgId);
  const { backPath, cartItemCount, showBackLink, showCart } = useAppHeaderNav();

  const brandName = getOrgBrandName(orgId);

  return (
    <header className="app-header">
      <div className="app-header__inner">
        <div className="app-header__start">
          {showBackLink && backPath && <AppHeaderBackLink backPath={backPath} />}
        </div>

        <div className="app-header__center">
          {brandName && (
            <span className="app-header__brand" title={brandName}>
              {brandName}
            </span>
          )}
        </div>

        <div className="app-header__end">
          {showCart && <AppHeaderCartLink cartItemCount={cartItemCount} />}
        </div>
      </div>
    </header>
  );
};

export default Header;
